import { isOnDev } from '../isOnDev/isOnDev';
import { PUBLIC_APP_ENV } from '$app/env/public';

export const isOnStaging = () => {
	return isOnDev() || PUBLIC_APP_ENV === 'staging';
};
